@if (value) {
    <mat-icon
        [class]="class"
        [matTooltip]="toolTip">
        {{ value }}
    </mat-icon>
}
@if (svgValue) {
    <mat-icon
        [class]="class"
        [matTooltip]="toolTip"
        [svgIcon]="svgValue">
    </mat-icon>
}
@if (!value && !svgValue) {
    <span>-</span>
}